module.exports = __webpack_public_path__ + "static/new-0d54877c4aa536b459ac6cf08a3936fd.png";